'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchRemote = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _shuffle = require('lodash/shuffle');

var _shuffle2 = _interopRequireDefault(_shuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = function transform(_ref) {
    var facets = _ref.facets,
        itemIDs = _ref.itemIDs,
        landingPageMetaData = _ref.landingPageMetaData,
        sort = _ref.sort,
        startIndex = _ref.startIndex,
        totalFound = _ref.totalFound;

    return {
        facets: facets,
        itemIDs: (0, _shuffle2.default)(itemIDs),
        landingPageMetaData: landingPageMetaData,
        sort: sort,
        startIndex: startIndex,
        totalFound: totalFound
    };
};

var SearchRemote = exports.SearchRemote = {
    // this is search ... need to adjust to use the category landing page endpoint
    fetchCategoryResults: function fetchCategoryResults(_ref2) {
        var deployment = _ref2.deployment,
            ids = _ref2.ids,
            searchQuery = _ref2.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var encodedIds = encodeURIComponent((0, _stringify2.default)(ids));

            var searchString = '<SEARCH-API>?ids=' + encodedIds;

            var encodedParams = encodeURIComponent((0, _stringify2.default)(searchQuery));
            searchString = searchString + '&parameters=' + encodedParams;

            var request = (0, _helpers.makeGet)({ apiPath: 'categoryweb', deployment: deployment, path: searchString });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchPromotedSearchResults: function fetchPromotedSearchResults(_ref3) {
        var deployment = _ref3.deployment,
            ids = _ref3.ids,
            searchQuery = _ref3.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var searchString = '<SEARCH-API>?promoted=1&parameters=' + encodeURIComponent((0, _stringify2.default)(searchQuery));
            var apiPath = 'web';
            if (ids && ids.length) {
                searchString = searchString + '&ids=' + encodeURIComponent((0, _stringify2.default)(ids));
                apiPath = 'categoryweb';
            } else if (searchQuery.campaignId && searchQuery.campaignId > 0) {
                searchString = searchString + '&ids=' + encodeURIComponent('[]');
                apiPath = 'categoryweb';
            }
            var request = (0, _helpers.makeGet)({ apiPath: apiPath, deployment: deployment, path: searchString });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: transform });
            });
        });
    },
    fetchSearchFacetsResults: function fetchSearchFacetsResults(_ref4) {
        var deployment = _ref4.deployment,
            searchQuery = _ref4.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({
                apiPath: 'faceted',
                deployment: deployment,
                path: '<SEARCH-API>?parameters=' + encodeURIComponent((0, _stringify2.default)(searchQuery))
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSearchResults: function fetchSearchResults(_ref5) {
        var deployment = _ref5.deployment,
            searchQuery = _ref5.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var buyNow = '';
            if (searchQuery.buyNow) {
                buyNow = '&buyNow=' + encodeURIComponent((0, _stringify2.default)(searchQuery.buyNow));
                delete searchQuery.buyNow;
            }

            var buyNowDate = '';
            if (searchQuery.buyNowDate) {
                var buyNowDateMoment = (0, _moment2.default)(searchQuery.buyNowDate);

                if (buyNowDateMoment.isValid()) {
                    var valueInSeconds = buyNowDateMoment.valueOf() / 1000;
                    buyNowDate = '&buyNowDate=' + encodeURIComponent(valueInSeconds);
                }
                delete searchQuery.buyNowDate;
            }

            var searchString = '<SEARCH-API>?parameters=' + encodeURIComponent((0, _stringify2.default)(searchQuery)) + buyNow + buyNowDate;

            var request = (0, _helpers.makeGet)({ apiPath: 'web', deployment: deployment, path: searchString, useCacheKey: false });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/search.js
// module id = 6t9d
// module chunks = 60